import { render, staticRenderFns } from "./LoanPaymentHistory.vue?vue&type=template&id=016b40b8&scoped=true&"
import script from "./LoanPaymentHistory.vue?vue&type=script&lang=js&"
export * from "./LoanPaymentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016b40b8",
  null
  
)

export default component.exports